module.exports = __webpack_public_path__ + "img/2015.2e0ea005.png";